import PropTypes from "prop-types";
import {
  ResponsiveContainer,
  Tooltip,
  Area,
  YAxis,
  XAxis,
  CartesianGrid,
  AreaChart,
} from "recharts";
import getRandomColor from "../../utils/randomColors";
import CustomizedAxisTick from "./customTick";

const toPercent = (decimal) => `${(decimal * 100).toFixed(0)}%`;
const getPercent = (value, total) => {
  const ratio = total > 0 ? value / total : 0;

  return `${(ratio * 100).toFixed(2)}%`;
};

const renderTooltipContent = (o) => {
  const { payload, label } = o;
  const total = payload.reduce((result, entry) => result + entry.value, 0);

  return (
    <div className="customized-tooltip-content">
      <p className="total">{`${label} (Total: ${total})`}</p>
      <ul className="list">
        {payload.map((entry, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={entry + index} style={{ color: entry.color }}>
            {`${entry.name}: ${entry.value}(${getPercent(entry.value, total)})`}
          </li>
        ))}
      </ul>
    </div>
  );
};

const MyPercentArea = ({ data, width }) => {
  const keys = Object.keys(data[0]).filter((key) => key !== "year");
  return (
    <ResponsiveContainer width={width} height="100%">
      <AreaChart
        width={500}
        height={width}
        data={data}
        stackOffset="expand"
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="year" padding={{ left: 15, right: 15 }} tick={<CustomizedAxisTick />} />
        <YAxis tickFormatter={toPercent} />
        <Tooltip content={renderTooltipContent} />

        {keys.map((key) => (
          <Area
            type="monotone"
            key={key}
            dataKey={key}
            stackId="a"
            stroke={getRandomColor(key)}
            fill={getRandomColor(key)}
          />
        ))}
      </AreaChart>
    </ResponsiveContainer>
  );
};

MyPercentArea.defaultProps = {
  data: [],
  width: 300,
};

MyPercentArea.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  width: PropTypes.number,
};
export default MyPercentArea;
